'use client';

import React, { useCallback } from 'react';
import { Button } from 'reactstrap';
import TruncatedText from 'src/components/shared/truncated-text';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux-hooks';
import { updateVisibility } from 'src/redux/modals/slice';

interface JobDescription {
  is_latest_job_description?: boolean;
  note?: string;
  [key: string]: unknown;
}

const Description: React.FC = () => {
  const {
    job_descriptions: jobDescriptions,
  } = useAppSelector(
    (state) => state.jobDetails.data,
  ) as { job_descriptions?: JobDescription[] };

  const dispatch = useAppDispatch();
  const currentJobDescription = jobDescriptions?.find(
    (jobDescription) => jobDescription.is_latest_job_description,
  );
  const { note } = currentJobDescription || {};

  const openDescriptionHistoryModal = useCallback(() => {
    dispatch((
      updateVisibility({
        modalType: 'descriptionHistoryModal',
        isVisible: true,
      })
    ));
  }, [dispatch]);

  return (
    <React.Fragment>

      <p>
        <TruncatedText textContent={note} />
      </p>
      <p className="update-time">
        <span>
          {jobDescriptions && jobDescriptions?.length > 1 ? (
            <Button
              type="button"
              className="grey-outline-btn"
              color="none"
              onClick={openDescriptionHistoryModal}
            >
              Description History (
              {jobDescriptions?.length || ''}
              )
            </Button>
          ) : ''}
        </span>
      </p>
    </React.Fragment>
  );
};

export default Description;
